class ImageCreate
    constructor: (options) ->
        @.$el = null

        @.alt = options?.alt ? false
        @.attrs = options?.attrs ? false
        @.cover = options?.cover ? false
        @.lazyLoad = options?.lazyLoad ? true
        @.src = options?.src ? false
        @.title = options?.title ? false
        @.width = options?.width ? false

        @.CreateElement()
        return @.$el

    CreateElement: ->
        if @.src
            @.$el = document.createElement 'img'
            if @.attrs
                @.$el = window.appUtils.Attributes @.attrs, @.$el
            @.$el.classList.add 'image'
            @.$el.src = @.src
            if @.alt
                @.$el.alt = @.alt
            if @.cover
                @.$el.classList.add 'image--cover'
            if @.lazyLoad
                @.$el.loading = 'lazy'
            if @.title
                @.$el.title = @.title
            if @.width
                @.$el.width = @.width
        return

window.CreateImage = (options) ->
    return new ImageCreate options